import React from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import MessagePage from '@dashboard/components/pages/MessagePage';
import { useInviteQuery } from '@dashboard/generated/wp/authentication';
import { Button, Container } from '@mui/material';

type Props = {
  inviteSecret: string;
  platformUserId: string;
};

export default function UnauthenticatedInvitePage({ platformUserId, inviteSecret }: Props): JsxNode {
  const { loginWithRedirect } = useAuth0();
  const { data } = useInviteQuery({ variables: { platformUserId, inviteSecret } });
  const invite = data?.invite;

  if (!invite) {
    return (
      <Container maxWidth="sm">
        <LoadingIndicator />
      </Container>
    );
  }

  function onClick() {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: 'signup',
        appState: {
          returnTo: window.location.href.replace(window.location.origin, ''),
        },
      },
    });
  }

  return (
    <MessagePage
      icon="PLANTS"
      title={`You've been invited to join "${invite.name}"`}
      description="As a collaborator on this Waypoint workspace, you'll be able to build and monitor email notifications with your team."
      action={
        <Button size="large" onClick={onClick} variant="contained">
          Sign up or login to join
        </Button>
      }
    />
  );
}
